"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");
/**
 * 再帰的に child node の value を収集
 */


var collectChildValues = function collectChildValues(values, children) {
  if (!children || !children.length) return values;
  values.push.apply(values, _toConsumableArray(children.map(function (node) {
    return node.value;
  })));
  return children.map(function (node) {
    return collectChildValues(values, node.children);
  }).flat();
};

var handleCollectParentValues = function handleCollectParentValues(targetValue) {
  return (
    /**
     * 再帰的に parent node の value を収集
     */
    function collectParentValues(nodeIndex, parentValues, nodes) {
      if (!nodes) return;
      var node = nodes[nodeIndex];

      if (!node) {
        for (var i = 0; i < nodes.length; i++) {
          var res = collectParentValues(0, [].concat(_toConsumableArray(parentValues), [nodes[i].value]), nodes[i].children);
          if (!!res) return res;
        }

        return;
      }

      if (node.value === targetValue) return parentValues;
      return collectParentValues(nodeIndex + 1, parentValues, nodes);
    }
  );
};

var useCheckedValues = function useCheckedValues(checkBoxNodes, onCheckedChange) {
  var _react_1$useState = react_1.useState([]),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      checked = _react_1$useState2[0],
      setChecked = _react_1$useState2[1];

  var handleChecked = react_1.useCallback(function (checkedValues, targetNode) {
    var isChild = targetNode.isChild,
        isParent = targetNode.isParent,
        checked = targetNode.checked,
        children = targetNode.children;
    /**
     * 親 かつ checke => 子も全て checked
     * 親 かつ unchecked => 子も全て unchecked
     */

    if (isParent) {
      var childValues = collectChildValues([], children);
      checkedValues = checked ? checkedValues.concat(childValues) : checkedValues.filter(function (value) {
        return !childValues.includes(value);
      });
    }
    /**
     * 子 かつ checked => 親も全て checked
     * 子 かつ unchecked => 何もおきない
     */


    if (isChild && checked) {
      var collectParentValues = handleCollectParentValues(targetNode.value);
      var parentValues = collectParentValues(0, [], checkBoxNodes);
      checkedValues = parentValues ? checkedValues.concat(parentValues) : checkedValues;
    }

    setChecked(checkedValues);
    onCheckedChange && onCheckedChange(checkedValues);
  }, [setChecked, onCheckedChange, checkBoxNodes]);
  return {
    checked: checked,
    handleChecked: handleChecked
  };
};

exports.default = useCheckedValues;